import React, { FunctionComponent } from 'react';
import { buttonVariants } from '@companion-professional/components';
import { cn } from '@companion-professional/webutils';

interface TapButtonProps {
  onClick?: () => void;
  children?: React.ReactNode;
}

// TapButton is a div styled as a full width primary button that is used for the tap actions.  It's a div (instead of
// a <Button />) because it's usually wrapped by <NativeCapture />, which handles the click to open the file input.
export const TapButton: FunctionComponent<TapButtonProps> = ({ children, onClick }) => {
  return (
    <div
      className={cn(
        buttonVariants({ variant: 'primary', size: 'large' }),
        'my-1 w-full max-w-lg cursor-pointer text-base sm:my-2 sm:text-lg'
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
